/**
*@Time : 2020/9/2 下午3:46
*@Author : Hejie Shao
*/
<template>
  <div class="product-container" :style="customStyle">
    <div class="main-content">
      <div class="left">
        <div class="prod-logo">
          <slot name="prologo"></slot>
        </div>
        <div class="pro-title">
          <slot name="protitle"></slot>
        </div>
        <div class="desc-text">
          <slot name="protext"></slot>
        </div>
        <a :href="link" class="more-detail" target="_blank" :style="linkStyle">
          <slot name="linkdetail"></slot>
        </a>
      </div>
      <div class="right">
        <slot name="proimage"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "productionItem",
  props:{
    link: String,
    background: String,
    linkColor: String
  },
  data() {
    return {}
  },
  computed:{
    customStyle(){
      return 'background:' + this.background + ";"
    },
    linkStyle(){
      return 'color:' + this.linkColor + ";"
    }
  },
  components: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss">
  @import "~@/assets/scss/globalFn.scss";
  .product-container{
    position: relative;
    width: 100%;
    height: 100%;
    //background: linear-gradient(270deg, #6EE1E1 0%, #59B3C3 100%);
    background-color: #101112;
    overflow: hidden;
    .main-content{
      position: absolute;
      top: cs(110);
      transform: translateX(50%);
      //left: cs(250);
      //right: cs(250);
      width: cs(940);
      //height: cs(723);
      height: auto;
      display: flex;
      margin: 0 auto;
      alignment: center;

      .left{
        width: cs(460);
        margin-top: cs(80);
        .prod-logo{
          width: cs(250);
          height: auto;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .pro-title{
          margin-top: cs(39);
          //font-size: cs(100);
          //font-weight: bold;
          //color: #FFFFFF;
          img{
            width: cs(350);
            height: auto;
            vertical-align: middle;
          }
        }
        .desc-text{
          max-width: cs(420);
          margin-top: cs(40);
          font-size: cs(16);
          //color: #FFFFFF;
          color: #979797;
        }
        .more-detail{
          width: cs(124);
          height: cs(38);
          margin-top: cs(60);
          //background-color: #FFFFFF;
          //border-radius: 20px;
          display: block;
          font-size: cs(16);
          text-align: center;
          font-weight: bold;
          &:hover{
            opacity: .8;
          }
          span{
            line-height: cs(38);
            vertical-align: middle;
            display: inline-block;
          }
          img{
            width: cs(8);
            height: auto;
            vertical-align: middle;
            margin-left: 8px;
            display: inline-block;
          }
        }
      }
      .right{
        margin-left: auto;
        width: cs(460);
        height: auto;
        img{
          width: 100%;
          height: auto;
        }
      }
    }
  }
</style>
